import AwsService from "../service/awsService";
import FetchApi from "./fetchApi";
const fetchApi = new FetchApi();

export default class AWSMultipartUploader {
  URLPartWise = [];
  maxThreadsAtOnce = 15;
  file = null;
  chunkSize = 1024 * 1024 * 10;
  batchArr = [];

  constructor(URLPartWise, file, chunkSize, maxThreadsAtOnce) {
    this.URLPartWise = URLPartWise;
    this.file = file;
    this.maxThreadsAtOnce = maxThreadsAtOnce;
    this.chunkSize = chunkSize;
    while (this.URLPartWise.length > 0) {
      const batch = this.URLPartWise.splice(0, this.maxThreadsAtOnce);
      this.batchArr.push(batch);
    }
  }

  async start() {
    let ETags = [];
    let has404Error = false;
    for (const [batchIndex, batch] of this.batchArr.entries()) {
      const batchResponse = await Promise.all(
        batch.map(async ({ signedUrl, PartNumber }, index) => {
          const partIndex = batchIndex * this.maxThreadsAtOnce + index;
          const response = await fetchApi.put(
            signedUrl,
            this.file.slice(partIndex * this.chunkSize, partIndex * this.chunkSize + this.chunkSize)
          );

          if (response?.status === 404) return { ETag: false, PartNumber, has404Error: true };

          return { ETag: response?.headers?.etag.replaceAll('"', "") || false, PartNumber };
        })
      );
      if (!batchResponse.some(({ ETag }) => !ETag)) ETags = [...ETags, ...batchResponse];
      else {
        has404Error = batchResponse.some(({ has404Error }) => has404Error);
        ETags = false;
        break;
      }
    }
    if (Array.isArray(ETags)) ETags.sort((a, b) => a.PartNumber - b.PartNumber);
    return { ETags, has404Error };
  }

  async complete(data) {
    const aws = new AwsService();
    return await aws.completeMultipartUpload(data);
  }

  async abort(data) {
    const aws = new AwsService();
    return await aws.abortMultipartUpload(data);
  }
}
